import React, { useState, useEffect } from "react";

const PHONE = "918588830840"; // India — country code + number, no +, no spaces
const MESSAGE = "Hi Sugandhi, I visited SilverTree and would love to chat about a project.";

const WhatsAppFloat = () => {
    const [visible, setVisible] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        // Show after a short delay so it doesn't fight the hero on first paint
        const t = setTimeout(() => setVisible(true), 1400);
        return () => clearTimeout(t);
    }, []);

    const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

    const onClick = () => {
        // Fire GA4 event so you can see conversion clicks in analytics
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("event", "whatsapp_click", {
                event_category: "engagement",
                event_label: "WhatsApp float button",
            });
        }
    };

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
            onMouseEnter={() => setExpanded(true)}
            onMouseLeave={() => setExpanded(false)}
            data-testid="whatsapp-float"
            aria-label="Chat with SilverTree on WhatsApp"
            className={`fixed z-40 bottom-6 right-6 lg:bottom-8 lg:right-8 flex items-center gap-3 rounded-full pl-4 pr-1.5 py-1.5 bg-[#25D366] text-white shadow-2xl transition-all duration-500 hover:scale-[1.04] hover:shadow-[0_20px_60px_-10px_rgba(37,211,102,0.6)] ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
            }`}
            style={{ boxShadow: "0 10px 40px -8px rgba(37, 211, 102, 0.45)" }}
        >
            <span
                className={`overflow-hidden whitespace-nowrap transition-all duration-500 ${
                    expanded ? "max-w-[220px] opacity-100" : "max-w-0 lg:max-w-0 opacity-0"
                }`}
            >
                <span className="text-[13px] font-medium tracking-wide pr-1">Chat with us</span>
            </span>
            <span className="w-11 h-11 rounded-full bg-white/15 flex items-center justify-center backdrop-blur-sm">
                {/* WhatsApp glyph */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="22"
                    height="22"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.55 4.14 1.6 5.94L2 22l4.28-1.12a9.9 9.9 0 0 0 5.75 1.83h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.83 9.83 0 0 0 12.04 2Zm0 18.11h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-2.55.67.68-2.48-.2-.32a8.2 8.2 0 0 1-1.26-4.34c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.42 5.82c0 4.54-3.7 8.24-8.65 8.24Zm4.52-6.16c-.25-.12-1.46-.72-1.69-.8-.22-.08-.39-.12-.55.13-.16.25-.63.8-.77.96-.14.16-.28.18-.53.06-.25-.12-1.05-.39-2-1.24a7.5 7.5 0 0 1-1.38-1.72c-.14-.25-.02-.38.11-.5.12-.11.25-.28.37-.42.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.55-1.33-.75-1.82-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.42.06-.64.31-.22.25-.83.81-.83 1.98s.85 2.29.97 2.45c.12.16 1.67 2.55 4.05 3.57.57.25 1.01.39 1.36.5.57.18 1.09.15 1.5.09.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.47-.28Z" />
                </svg>
            </span>
        </a>
    );
};

export default WhatsAppFloat;
